<template>
  <div class="user_table">
    <el-dialog
      :visible.sync="publishVisible"
      title="上传新封面"
      :before-close="clear_fun"
    >
      <el-form :model="form" ref="form">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input
            v-model="form.name"
            placeholder="请输入名称"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            :rows="4"
            v-model="form.desc"
            placeholder="请输入描述"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传" :label-width="formLabelWidth">
          <template>
            <div class="up-area">
              <input
                class="upload"
                @change="selectedFile"
                type="file"
                value="+"
              />
              <div class="up_icon" v-show="imageUrl == ''">+</div>
              <img class="imagelist" :src="imageUrl" alt />
            </div>
          </template>
        </el-form-item>

        <el-form-item label="超链接" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            v-model="form.url"
            placeholder="请输入banner跳转的超链接"
            autocomplete="off"
            :rows="4"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="clear_fun">取 消</el-button>
        <el-button type="primary" @click="go_update">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>
<script>
import { pic_banner, get_id, new_banner } from "@/api/banner";
import { user_detail } from "@/api/user";
var Bucket = "ddbes-repository-1304188286";
var Region = "ap-beijing";
var cos = new COS({
  FileParallelLimit: 5,
  ChunkParallelLimit: 5,
  ChunkMbSize: 8 * 1024 * 1024,
  getAuthorization: function (options, callback) {
    pic_banner()
      .then((res) => {
        var data = res.data;
        callback({
          TmpSecretId: data.credentials && data.credentials.tmpSecretId,
          TmpSecretKey: data.credentials && data.credentials.tmpSecretKey,
          XCosSecurityToken: data.credentials && data.credentials.sessionToken,
          ExpiredTime: data.expiredTime,
        });
      })
      .catch((error) => {});
  },
});

export default {
  data() {
    return {
      text_in: "+",
      publishVisible: false,
      dialogImageUrl: "",
      isImage: true,
      dialogVisible: false,
      picture: "",
      id: "",
      mySrc: "",
      form: {
        name: "",
        desc: "",
        picture: "",
        url: "",
      },
      list: [],
      imageUrl: "",
      formLabelWidth: "80px",
    };
  },
  methods: {
    clear_fun() {
      this.publishVisible = false;
      this.form.name = "";
      this.form.desc = "";
      this.form.picture = "";
      this.form.url = "";
    },
    selectedFile(e) {
      var files = e.target.files;
      get_id()
        .then((res) => {
          var list = [].map.call(files, function (f) {
            return {
              Bucket: Bucket,
              Region: Region,
              Key: "BANNER/" + res.data[0],
              Body: f,
            };
          });
          let that = this;
          cos.uploadFiles({
            files: list,
            onFileFinish(err, data, options) {
              that.picture =
                "https://ddbes-repository-1304188286.cos.ap-beijing.myqcloud.com/" +
                options.Key;
              that.imageUrl = that.picture;
            },
          });
        })
        .catch((error) => {});
    },
    go_update() {
      let data = {
        createTime: 0,
        desc: this.form.desc,
        id: this.id,
        name: this.form.name,
        picture: this.picture,
        status: 0,
        url: this.form.url,
      };
      new_banner(data)
        .then((res) => {
          this.publishVisible = false;
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.clear_fun();
          this.$emit("banner_fun");
        })
        .catch((error) => {
          this.$message({
            message: error.msg,
          });
        });
    },
    //删除当前选择照片
    go_delete() {},
    init() {
      this.publishVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.disabled {
  /deep/.el-upload--picture-card {
    display: none;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  position: relative;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.el-icon-error {
  position: absolute;
  top: 0px;
  left: 80px;
  z-index: 99;
  color: #fff;
  font-size: 20px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
/deep/.el-upload-list__item,
/deep/.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.user_table {
  .up-area {
    border: 1px dashed $border_e;
    width: 90px;
    height: 90px;
    position: relative;
  }
  .upload {
    border: 1px dashed $border_e;
    position: absolute;
    top: 0;
    width: 90px;
    height: 90px;
    opacity: 0;
    z-index: 10;
    /deep/.el-input__inner {
      opacity: 0;
      height: 100%;
    }
  }
  .up_icon {
    font-size: 40px;
    font-weight: 10;
    color: #e2e2e2;
    position: absolute;
    top: 25px;
    left: 30px;
  }
  .imagelist {
    width: 90px;
    height: 90px;
    position: absolute;
    top: 0;
  }
  .file {
    position: relative;
    width: 100px;
    height: 100px;
    border: 1px solid $border_e;
    border-radius: 4px;
  }
  .mySrc {
    line-height: 100px;
    width: 100px;
    height: 100px;
    border-radius: 4px;
  }

  /deep/.el-dialog {
    .el-upload {
      border: 1px dashed $border_e;
    }
    width: 502px;
    @include dia_header_usual;
    @include dia_form;
    .el-form-item__label {
      text-align: left;
    }
  }
}
</style>